"use client";

import { useEffect, useState } from "react";

function MswInitializer({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [isMswLoad, setIsMswLoad] = useState(false);

  const initMSW = async () => {
    // const { worker } = await import("../utils/mocks/api-mocks/browser");
    // await worker.start({ onUnhandledRequest: "bypass" });
    // setIsMswLoad(true);
  };

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      process.env.NEXT_PUBLIC_USE_MOCK_API === "true" &&
      process.env.NODE_ENV !== "test"
    ) {
      initMSW();
    } else if (process.env.NEXT_PUBLIC_USE_MOCK_API !== "true") {
      setIsMswLoad(true);
    }
  }, []);

  return <div>{isMswLoad ? children : null}</div>;
}

export default MswInitializer;
